import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Fade from 'react-reveal/Fade'

import Link from '../../utils/link'
import parse from 'html-react-parser'
import { Arrow } from '../icons'

const MachineCard = ({ title = '', uri = '', excerpt = '', featuredImage = null, subMachines = null, sites }) => {

  const show = !!sites?.nodes?.find(site => site.slug === process.env.GATSBY_WP_CATEGORY_SITE_SLUG)
  if (sites?.nodes.length > 0 && !show) return null

  return (
    <Fade bottom distance={'40px'}>
      <div className='machine-card'>
        <div className='machine-card__image'>
          { featuredImage?.node?.localFile && <GatsbyImage loading='lazy' image={getImage(featuredImage?.node.localFile)} alt={title} /> }
        </div>
        <div className='machine-card__content'>
          <h3>{ title }</h3>
          <div className='machine-card__excerpt'>{ excerpt && parse(excerpt) }</div>
          { subMachines?.length > 0 &&
            <ul className='machine-card__sub-machines'>
              { subMachines?.map((el, i) => (
                <li key={i}>
                  <h4>
                    <span className='square' />
                    <span className='title'>{el.title && parse(el.title)}</span>
                  </h4>
                  <span>{el.content && parse(el.content)}</span>
                </li>
              )) }
            </ul>
          }
          <Link to={uri} className='btn btn--arrow'>
            <span>{'Learn more'}</span>
            <Arrow />
          </Link>
        </div>
      </div>
    </Fade>
  )
}

export default MachineCard
